"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorageListColumns = useStorageListColumns;
const swr_1 = __importDefault(require("swr"));
const utils_1 = require("../utils");
const useStorageClient_1 = require("./useStorageClient");
/**
 * Calls `storage.listColumns` and returns an SWR response. SWR middleware `laggy` is used to make flipping
 * between pages look better, this is done by keeping previously loaded data while new data is loading.
 * SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param entity - entity name
 * @param request - request to pass to `storageClient.list`, this is optional, if not set backend will not be called and result will not be returned
 * @param columns - list of columns to retrieve
 * @param baseUrl - optional base URL
 * @param tokenProvider - optional token provider
 * @param config - custom SWR configuration object, can be used to remove the custom `laggy` middleware
 */
function useStorageListColumns(entity, request, columns, baseUrl, tokenProvider, config) {
    const storage = (0, useStorageClient_1.useStorageClient)(entity, baseUrl, tokenProvider);
    return (0, swr_1.default)(request ? [`/platform/storage/${entity}/listColumns`, request, columns] : null, async ([, request]) => {
        return request ? storage.listColumns(request, ...(columns ?? [])) : undefined;
    }, config ?? {
        use: [utils_1.laggy],
        revalidateOnFocus: false,
    });
}
